// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f28827a2","680":"e42887a7"}[chunkId] + ".chunk.js";
};